var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block-storage-list',{attrs:{"id":_vm.id,"getParams":_vm.getParams,"cloudEnv":_vm.cloudEnv,"hidenGroupActions":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }